<template>
	<div class="xs-12">
		<!-- Question -->
		<div class="fw7 fs3 pb1">{{ $t("question") }}</div>
		<j-base-input-text
			class="xs"
			size="small"
			:value="value"
			@input="item.localizedContent = $event"
			@blur="$emit('blur')"
		/>

		<!-- Options -->
		<div class="r2 b1 bc7 mt4 p2">
			<div class="xs-12 flex xs-between bg5">
				<div class="fw7 fs3 xs-8">{{ $t("options") }}</div>
				<div class="fw7 fs3 xs-2 ta3">{{ $t("is_correct") }}</div>
				<div class="fw7 fs3 xs-2 ta3">{{ $t("remove") }}</div>
			</div>
			<div v-for="(option, i) in options" :key="i" class="flex mt1 xs-middle">
				<j-base-input-text
					class="xs-8"
					size="small"
					v-model="option.localizedContent"
					@blur="updateOptionLocalization(option)"
				/>
				<div class="xs-2 flex xs-right">
					<j-checkbox
						v-model="option.isCorrect"
						@input="onInputIsCorrect(option)"
					/>
				</div>
				<div class="xs-2 flex xs-right">
					<div class="cu2" @click="removeOptionFromItem(option)">
						<crm-icon name="delete" color="cError" />
					</div>
				</div>
			</div>
			<j-button type="tertiary" size="xsmall" @click="addOptionToLessonItem"
				>+{{ $t("add_option") }}</j-button
			>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import JBaseInputText from "@/components/JBaseInputText"
import JCheckbox from "@/components/JCheckbox"
import CrmIcon from "@/components/CrmIcon"

import { checkSuccess } from "../utils/helpers.js"
import api from "@/api/gql.js"
import queries from "../utils/queries.js"

export default {
	props: {
		// localized content
		value: String,

		// Full item
		item: Object,

		// Ids of course and lesson, needed for the calls
		courseId: String,
		lessonId: String,

		selectedLocale: String
	},

	components: {
		JCheckbox,
		JButton,
		JBaseInputText,
		CrmIcon
	},

	data() {
		return {
			isLoading: false
		}
	},

	computed: {
		options() {
			return this.item?.options || []
		}
	},

	methods: {
		async addOptionToLessonItem() {
			if (this.isLoading) return
			let variables = {
				courseId: this.courseId,
				lessonId: this.lessonId,
				itemId: this.item.id,
				input: {
					isCorrect: false
				}
			}

			this.isLoading = true

			let res = await api({ query: queries.addOptionToLessonItem, variables })

			this.isLoading = false

			if (
				!checkSuccess(
					res,
					"addOptionToLessonItem",
					this.$t("errors.general"),
					this.$store
				)
			)
				return
			this.$emit("option:added")
		},

		async updateOptionLocalization(option) {
			if (this.isLoading) return
			if (!option?.localizedContent) return
			const variables = {
				l10n: {
					key: `lessonItemsOptions-${option.id}-content`,
					locale: this.selectedLocale,
					value: option.localizedContent
				}
			}

			this.isLoading = true

			const res = await api({ query: queries.upsertL10n, variables })
			this.isLoading = false

			if (
				!checkSuccess(res, "upsertL10n", this.$t("errors.general"), this.$store)
			)
				return
			this.$emit("option:updated")
		},

		async onInputIsCorrect(option) {
			if (this.isLoading) return
			let variables = {
				courseId: this.courseId,
				lessonId: this.lessonId,
				itemId: this.item.id,
				optionId: option.id,
				input: {
					isCorrect: option.isCorrect
				}
			}

			this.isLoading = true

			let res = await api({
				query: queries.updateOptionOfLessonItem,
				variables
			})

			this.isLoading = false

			if (
				!checkSuccess(
					res,
					"updateOptionOfLessonItem",
					this.$t("errors.general"),
					this.$store
				)
			) {
				return
			}
			this.$emit("option:updated")
		},

		async removeOptionFromItem(option) {
			if (this.isLoading) return
			// Remove item from lesson
			let variables = {
				courseId: this.courseId,
				lessonId: this.lessonId,
				itemId: this.item.id,
				optionId: option.id
			}

			this.isLoading = true

			let res = await api({
				query: queries.removeOptionFromLessonItem,
				variables
			})

			if (
				!checkSuccess(
					res,
					"removeOptionFromLessonItem",
					this.$t("errors.general"),
					this.$store
				)
			) {
				this.isLoading = false
				return
			}
			// Delete l10n localizedContent
			variables = {
				key: `lessonItemsOptions-${option.id}-content`
			}
			res = await api({ query: queries.deleteAllL10n, variables })
			this.isLoading = false
			this.$emit("option:removed")
		}
	}
}
</script>
